import { Component } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { TdLoadingService } from '@covalent/core';

import { Category, AbstractIdeaList } from '../../shared';
import { IdeaService } from '../../services/idea.service';
import { AdminService } from '../../services/admin/admin.service';
import { PetitionAdminConfigs } from '../../shared/admin-models/interfaces/petition-admin-configs.interface';

@Component({
  selector: 'app-category-details',
  templateUrl: './category-details.component.html',
  styleUrls: ['./category-details.component.scss']
})
export class CategoryDetailsComponent extends AbstractIdeaList {
  signersNeededAmount: number;

  /**
   * Constructor
   *
   * @param _router
   * @param _activatedRoute
   * @param _loadingService
   * @param _ideaService
   */
  constructor(
    protected _router: Router,
    protected _activatedRoute: ActivatedRoute,
    protected _loadingService: TdLoadingService,
    protected _ideaService: IdeaService,
    private adminService: AdminService
  ) {
    super(_activatedRoute, _loadingService, _ideaService);
  }

  /**
   * Init
   */
  ngOnInit() {
    this._subs.add(
      this._activatedRoute.params.subscribe((params) => {
        const { id } = params;
        this.searchParams = { categoryId: id };
        this._getAllIdeas();
      })
    );
    this.getconfigs();
  }
  getconfigs(): void {
    this.adminService.getConfigs().subscribe((res: PetitionAdminConfigs) => {
      this.signersNeededAmount = res.petitionCounterValue;
    });
  }
  /**
   * Returns the category
   */
  get category() {
    return this.categories[0];
  }

  /**
   * Category description map
   */
  get descriptions() {
    return Category.descriptions;
  }

  /**
   * Gets categories
   */
  protected _getCategories() {
    const data = Object.assign(
      { statusIds: this._statuses },
      this.searchParams
    );
    return this._getCategoriesBase(data).do((res) => {
      if (this.categories.length === 0) {
        this._router.navigate(['/category-list']);
      }
    });
  }

  /**
   * Style for background
   */
  get style() {
    const style = {
      '3': '#7C7C7C', // "საგზაო ინფრასტრუქტურა",
      '4': '#536DFE', // "სატრანსპორტო ინფრასტრუქტურა ",
      '5': '#F16522', // "ნარჩენების მართვა",
      '6': '#00B0FF', // "წყალმომარაგება-წყალარინება",
      '7': '#898890', // "გარე განათება",
      '8': '#4CAF50', // "გამწვანება",
      '9': '#6699CC', // "სკოლამდელი, არაფორმალური და პროფესიული განათლება",
      '10': '#757575', // "შშმ პირთა ინკლუზია და მათთვის გარემოს ადაპტაცია",
      '11': '#E3B16F', // "კულტურული, სპორტული ან ახალგაზრდული საკითხები",
      '12': '#EF5350', // "ჯანმრთელობის დაცვა და სოციალური უზრუნველყოფა\n",
      '13': '#00C853', // "ჯანსაღი და უსაფრთხო საცხოვრებელი გარემო",
      '14': '#3949AB', // "ღია და კარგი მმართველობა",
      '21': '#DCB86F', // "მერიის კომპეტენციას მიკუთვნებული სხვა საკითხები"
      '22': '#1C4E78' // "ეკონომიკური განვითარება"
    };

    return {
      'background-color': style[this.category.keyword] || '#7C7C7C'
    };
  }
}



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/components/category-details/category-details.component.ts